import axios from "axios";
import { toast } from "react-toastify";

const Api = axios.create({
  baseURL: "https://api.havirkesht.ir",
});

// Function to refresh the access token
const refreshAccessToken = async () => {
  try {
    const refreshToken = localStorage.getItem("app_rtkey");
    if (!refreshToken) {
      throw new Error("Refresh token not found");
    }
    const response = await axios.post(
      "https://api.havirkesht.ir/refresh-token",
      { app_rtkey: refreshToken },
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    localStorage.setItem("app_atkey", response.data.app_atkey);
    toast.success("Token successfully refreshed");
    return response.data.app_atkey;
  } catch (error) {
    toast.error("نام کاربری یا رمز عبور اشتباه است");
    localStorage.clear();
  }
};
// Adding interceptor to handle the token refresh
Api.interceptors.response.use(
  async (response: any) => {
    if (response?.data?.refresh_token) {
      try {
        const res = await axios.post(
          `https://api.havirkesht.ir/refresh-token?refresh_token=${response?.data?.refresh_token}`
        );
        if (res) {
          localStorage.setItem("app_atkey", res?.data.access_token);
          localStorage.setItem("app_rtkey", res.data.refresh_token);
        }
      } catch (err) {
        toast.error("مشکلی پیش امده لطفا مجدد وارد شوید");
        localStorage.removeItem("app_atkey");
        localStorage.removeItem("app_rtkey");
        console.error("Error getting new refresh token:", err);
      }
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const newAccessToken = await refreshAccessToken();
        if (newAccessToken) {
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return Api(originalRequest);
        }
      } catch (refreshError) {
        console.error("Error refreshing token:", refreshError);
        localStorage.clear();
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

// Adding interceptor to handle the token refresh
// Api.interceptors.response.use(
//   (response: any) => {
//     if (response?.data?.app_rtkey) {
//       await    axios.post(`https://api.makimal.ir/refresh-token?app_rtkey=${response?.data.app_rtkey}`,).then(res => {
//         if(response?.data.app_rtkey){
//           localStorage.removeItem('app_atkey');
//           localStorage.setItem('app_atkey', res?.data.app_atkey);
//         }
//       }).catch(err => {
//         console.error('Error getting new refresh token:', err);
//       });
//     }
//     return response;
//   },
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;
//       try {
//         const newAccessToken = await refreshAccessToken();
//         if (newAccessToken) {
//           originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
//           return Api(originalRequest); // Retry the request with the new access token
//         }
//       } catch (refreshError) {
//         console.error('Error refreshing token:', refreshError);
//         localStorage.clear();
//         window.location.href = '/login'; // Redirect to login if refresh fails
//       }
//     }
//     return Promise.reject(error);
//   }
// );

export default Api;

// import axios from 'axios';
// import { toast } from 'react-toastify';

// const Api = axios.create({
//   baseURL: 'https://api.makimal.ir',
// });

// // افزودن اینترسپتور برای رفرش توکن
// Api.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response?.status === 401 || !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const refreshToken = localStorage.getItem('app_rtkey');
//         const response = await axios.post('/refresh-token', { app_rtkey: refreshToken });
//         localStorage.setItem('app_atkey', response.data.app_atkey);
//         // افزودن توکن جدید و ارسال مجدد درخواست
//         originalRequest.headers['Authorization'] = `Bearer ${response?.data.app_atkey}`;
//         return Api(originalRequest);
//       } catch (refreshError) {
//         toast.error('نشست شما به پایان رسیده است، لطفا دوباره وارد شوید');
//         localStorage.removeItem('app_atkey');
//         localStorage.removeItem('app_rtkey');
//         window.location.href = '/login';
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default Api;
